import { registryApi } from '../clients/AxiosClients'

export const getAllMapsByFazendaId = async (fazendaId) => {
	try {
		return await registryApi.get(`v1/Gis/GetAllMapsByFazendaId?fazendaId=${fazendaId}`)
	} catch (error) {
		console.err('🚀 ~ file: Gis.js ~ line 12 ~ getAllMapsByFazendaId ~ error', error)
	}
}

export const buscarPoligonosParaPlenajementoDeCronogramaDeOrdemDeServico = async (filtro) => {
	return await registryApi.post(
		'v1/gis/buscar-poligonos-para-cronograma-de-ordem-de-servico',
		filtro,
	)
}
